if (!customElements.get('store-availability-grid')) {
  customElements.define(
    'store-availability-grid',
    class StoreAvailabilityGrid extends HTMLElement {
      constructor() {
        super();
        this.currentVariantId = this.dataset.variantId || null;
        this.sectionId = this.dataset.sectionId || 'store-availability-grid';
        // Normalise base URL to guarantee a single trailing slash.
        this.baseUrl = (this.dataset.baseUrl || '/').replace(/\/?$/, '/');
        this.checkVariant = this.checkVariant.bind(this);
        this.onFormChange = this.onFormChange.bind(this);
      }

      connectedCallback() {
        const productForm =
          this.closest('.product-form') ||
          this.closest('product-form') ||
          document;
        this.form =
          (productForm.querySelector && productForm.querySelector('form[action*="/cart/add"]')) ||
          document.querySelector('form[action*="/cart/add"]');
        this.idInput =
          (this.form && this.form.querySelector('[name="id"]')) ||
          document.querySelector('form[action*="/cart/add"] [name="id"]');

        if (this.form) this.form.addEventListener('change', this.onFormChange);
        if (this.idInput) {
          this.observer = new MutationObserver(this.checkVariant);
          this.observer.observe(this.idInput, { attributes: true, attributeFilter: ['value'] });
        }
        // Fallback poll: many themes set input.value as a JS property, which does
        // not fire a mutation or change event. Cheap: just reads one string.
        this.poll = setInterval(this.checkVariant, 700);
      }

      disconnectedCallback() {
        if (this.form) this.form.removeEventListener('change', this.onFormChange);
        if (this.observer) this.observer.disconnect();
        if (this.poll) clearInterval(this.poll);
      }

      onFormChange() {
        // Give the theme a tick to update the hidden variant id first.
        setTimeout(this.checkVariant, 60);
      }

      getVariantId() {
        if (this.idInput && this.idInput.value) return String(this.idInput.value);
        return this.currentVariantId;
      }

      checkVariant() {
        const id = this.getVariantId();
        if (!id || id === this.currentVariantId) return;
        this.currentVariantId = id;
        this.fetchAvailability(id);
      }

      fetchAvailability(variantId) {
        const url = `${this.baseUrl}variants/${variantId}/?section_id=${this.sectionId}`;
        fetch(url)
          .then((response) => (response.ok ? response.text() : Promise.reject(response.status)))
          .then((text) => {
            const fresh = new DOMParser()
              .parseFromString(text, 'text/html')
              .querySelector('[data-store-availability-grid]');
            const current = this.querySelector('[data-store-availability-grid]');
            if (fresh && current) current.replaceWith(fresh);
          })
          .catch(() => {
            /* leave last-known state in place on error */
          });
      }
    }
  );
}
